module.exports = __webpack_public_path__ + "static/yildiz-entegre-1-5d59247911b3b5f15e477956de42630b.png";